import easyfyAxios from '@shared/easyfy.axios';

export const GetPlacements = async (data: GetPlacementsRequest): Promise<any> => {
  return await easyfyAxios.post('/api/kevelplacements', data);
};

export const GetKevelAdPlacement = async (slot: string, data: GetKevelAdPlacementRequest): Promise<any> => {
  return await easyfyAxios.post('/api/keveladplacement', { ...data, slot });
};

export interface GetKevelAdPlacementRequest {
  decisionApiRequest: DecisionApiRequest;
  divName: string;
}

export interface KevelAdData {
  imageUrl: string;
  linkUrl?: string;
  imageAltText?: string;
  impressionUrl?: string;
  clickUrl?: string;
  promotionId?: string;
  promotionName?: string;
}

export interface GetPlacementsRequest {
  decisionApiRequest: DecisionApiRequest;
  containers: Container[];
}

export interface DecisionApiRequest {
  user: User;
  consent: Consent;
  placements: Placement[];
  keywords: string[];
  url: string;
}

export interface User {
  key: string;
}

export interface Consent {
  gdpr: boolean;
}

export interface Placement {
  divName: string;
  adTypes: number[];
  zoneIds?: number[];
  count: number;
}

export interface Container {
  listName: string;
  listId?: string | null;
  divName: string;
  productCardType: number;
  isSlider: boolean;
  count: number;
  creativeSlot?: string;
}

export interface KevelPlaceholder {
  listName: string;
  listId?: string | null;
  divName: string;
  productCardType: number;
  adTypes: number[];
  zones?: number[];
  count: number;
  keywords: string[];
  element: HTMLElement;
  isSlider: boolean;
  promotionId?: string;
  promotionName?: string;
  creativeSlot?: string;
}

export interface RenderedProductCardsResponse {
  productCards: RenderedProductCardsCollection[];
  eventLayer: any;
}

export interface RenderedProductCardsCollection {
  containerId: string;
  partials: string[];
  isSlider: boolean;
}
